import { render, staticRenderFns } from "./GetSaveImgType.vue?vue&type=template&id=1aab8d76&scoped=true"
import script from "./GetSaveImgType.vue?vue&type=script&lang=js"
export * from "./GetSaveImgType.vue?vue&type=script&lang=js"
import style0 from "./GetSaveImgType.vue?vue&type=style&index=0&id=1aab8d76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab8d76",
  null
  
)

export default component.exports